"use client";
import Car from "@/components/ui/icons/car";
import Calendar from "@/components/ui/icons/calender";
import User from "@/components/ui/icons/contact";
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import { MoveUpRight } from "lucide-react";
import { useTranslations } from "next-intl";

const ICON_KEYS = ["car", "calendar", "user"] as const;

interface HelpCTASectionProps {
  className?: string;
}

export function HelpCTASection({ className }: HelpCTASectionProps) {
  const t = useTranslations('helpCta');
  const router = useRouter();

  const options = t.raw('options') as Array<{ title: string; description: string }>;

  const getIcon = (iconType: string) => {
    switch (iconType) {
      case "car": return <Car className="h-8 w-8 text-black" />;
      case "calendar": return <Calendar className="h-8 w-8 text-black" />;
      case "user": return <User className="h-8 w-8 text-black" />;
      default: return <Car className="h-8 w-8 text-black" />;
    }
  };
  return (
    <section className={cn("py-24 font-outfit ", className)}>
      <div className="mx-4 md:mx-16 lg:mx-20">
        <h2 className="text-3xl md:text-5xl font-medium text-yellow-500 text-center mb-16">
          {t('heading')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 py-8 gap-8">
          {options.map((option, index) => (
            <div key={index} className="text-left rounded-lg p-4">
              <div className="flex justify-between">
                <div className="bg-yellow-500 rounded-full w-20 h-20 flex items-center justify-center me-auto mb-6">
                  {getIcon(ICON_KEYS[index])}
                </div>
                <MoveUpRight
                  color="#f6ce21"
                  className="cursor-pointer"
                  onClick={() => router.push("/about/contact")}
                />
              </div>
              <h3 className="text-xl font-medium text-yellow-500 mb-4">{option.title}</h3>
              <p className="text-white font-thin leading-relaxed">{option.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
